import React, {
  useState, useEffect, Redirect,
} from 'react';
import {
  Form, Input, Button, Select, Layout, Row, Col, Card, Breadcrumb, Switch, Space, Upload, List, message, Menu, Checkbox
} from 'antd';
import { Link } from 'react-router-dom';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import Axios from 'axios';
import moment from 'moment';
import { url } from '../../config/global';

// const { Title } = Typography;
const { Option } = Select;
const { Content } = Layout;
const { SubMenu } = Menu;

const layout = {
  labelCol: {
    lg: 8,
    md: 10,
  },
  wrapperCol: {
    lg: 14,
    md: 14,
  },
};

function EditUser(props) {
  const [data, setData] = useState({
    username: '',
    full_name: '',
    npk: '',
    division: '',
    department: '',
    position: '',
    email: '',
    password: '',
    password_confirmation: '',
    number_phone: '',
    user_type: '',
    vendor: '',
    role_id: '',
    role_name: '',
    refer_id: '',
    refer_name: '',
    photo: null,
    roles_apps_status: '',
    roles_apps: '',
    two_factor_enabled: true,
    two_factor_methods: ['authenticator', 'email'],
    roles: [],
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadVendor, setLoadVendor] = useState(false);
  const [getApps, setGetApps] = useState([]);
  const [roleApps, setRoleApps] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [roleApp, setRoleApp] = useState([]);

  const getUser = () => {
    Axios.get(`${url}/user/${props.match.params.id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    }).then((res) => {
      setData({
        ...data,
        username: res.data.data.username,
        full_name: res.data.data.full_name,
        division: res.data.data.division,
        department: res.data.data.department,
        npk: res.data.data.npk,
        position: res.data.data.position,
        email: res.data.data.email,
        number_phone: res.data.data.number_phone,
        user_type: res.data.data.user_type,
        vendor_name: res.data.data.vendor_name,
        role_user_destinatio_id: res.data.data.role_user_destination_id,
        role_user_destination_name: res.data.data.role_user_destination,
        role_id: res.data.data.role_id,
        role_name: res.data.data.role_name,
        roles_apps_status: res.data.data.role_apps_status,
        roles_apps: res.data.data.role_apps,
        two_factor_enabled: res.data.data.two_factor_enabled !== false,
        two_factor_methods: res.data.data.two_factor_methods || ['authenticator', 'email'],
        refer_id: res.data.data.refer_id,
        refer_name: res.data.data.refer_name,
      });
      setRoleApps(JSON.parse(res.data.data.role_apps))
    }).catch((err) => {
      if (err.response) {
        message.error(err.response.data.message);
        if (err.response.status === 401) {
          sessionStorage.removeItem('token');
        }
      }
    });
  };

  const handleRemove = () => {
    setData({
      ...data,
      photo: null,
    });
  };

  const handleBeforeUpload = (files) => {
    setData({
      ...data,
      photo: files,
    });

    return false;
  };

  const getRoleNameProjects = async () => {
    await Axios.get(`${url}/settings/find`, {
      params: {
        variable: 'role_apps',
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    })
      .then((res) => {
        setRoleApp(res.data.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem('token');
          }
        }
      });
  };

  const getRole = async (keyword) => {
    await Axios.get(`${url}/role/list`, {
      params: {
        keyword,
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    }).then((res) => {
      setData({
        ...data,
        roles: res.data.data,
      });
    }).catch((err) => {
      if (err.response) {
        message.error(err.response.data.message);
        if (err.response.status === 401) {
          sessionStorage.removeItem('token');
        }
      }
    });
  };

  const handleChange = (name, value) => {
    setError(null);
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleChangeSwitch = (name, value) => {
    setRoleApps({
      ...roleApps,
      [name]: value,
    });
  };

  const handleChangeSelect = (name, value) => {
    setError(null);
    setData({
      ...data,
      [`${name}_id`]: value.value,
      [`${name}_name`]: value.label,
    });
  };

  const getVendor = async () => {
    setLoadVendor(true);

    await Axios.get(`${url}/settings/find`, {
      params: {
        variable: 'vendor_name',
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    })
      .then((res) => {
        setVendor(res.data.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem('token');
          }
        }
      });
    setLoadVendor(false);
  };

  const getAppsRole = () => {
    setLoading(true);

    Axios.get(`${url}/apps`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    })
      .then((res) => {
        setGetApps(res.data.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 422) {
            setError(err.response.data.errors);
          }
          if (err.response.status === 401) {
            sessionStorage.removeItem('token');
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  const handleChangeSelectVendor = (name, value) => {
    setError(null);

    if (name === 'vendor') {
      setData({
        ...data,
        [`${name}_id`]: value.value,
        [`${name}_name`]: value.label,
      });
    } else {
      setData({
        ...data,
        [`${name}_id`]: '',
        [`${name}_name`]: '',
      });
    }
  };

  const onSaveData = () => {
    setLoading(true);

    let fd = new FormData();

    fd.set("username", data.username);
    fd.set("full_name", data.full_name);
    fd.set("npk", data.npk);
    fd.set("division", data.division);
    fd.set("department", data.department);
    fd.set("position", data.position);
    fd.set("email", data.email);
    if (data.password) {
      fd.set("password", data.password);
      fd.set("password_confirmation", data.password_confirmation);
    }
    fd.set("number_phone", data.number_phone);
    fd.set("user_type", data.user_type);
    fd.set("vendor_id", data.vendor_id);
    fd.set("vendor_code", data.vendor_code);
    fd.set("vendor_name", data.vendor_name);
    fd.set("role_user_destination_id", data.role_user_destination_id);
    fd.set("role_user_destination", data.role_user_destination_name);
    fd.set("role_id", data.role_id);
    fd.set("role_name", data.role_name);
    fd.set("role_apps_status", data.roles_apps_status);
    fd.set("role_apps", JSON.stringify(roleApps));
    fd.set("two_factor_enabled", data.two_factor_enabled ? 1 : 0);
    fd.set("two_factor_methods", JSON.stringify(data.two_factor_methods));
    fd.append("photo", data.photo);

    Axios.post(`${url}/user/${props.match.params.id}`, fd,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    }).then((res) => {
      message.success(res.data.message);
      props.history.push('/user');
    }).catch((err) => {
      if (err.response) {
        message.error(err.response.data.message);
        if (err.response.status === 422) {
          setError(err.response.data.errors);
        }
        if (err.response.status === 401) {
          sessionStorage.removeItem('token');
        }
      }
      setLoading(false);
    });
  };

  const handleReset = () => {
    setData({
      username: '',
      full_name: '',
      npk: '',
      division: '',
      department: '',
      position: '',
      email: '',
      number_phone: '',
      user_type: '',
      vendor: '',
      role_id: '',
      roles_apps_status: '',
      roles_apps: '',
      two_factor_enabled: true,
      two_factor_methods: ['authenticator', 'email'],
      photo: null,
    });
  };

  useEffect(() => {
    getUser();
    getAppsRole();
  }, []);

  if (!sessionStorage.getItem('token')) {
    return <Redirect to="/login" />;
  }

  return (
    <>
      <Content className="content m-0">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Form {...layout} labelAlign="left" name="control-hooks" onFinish={onSaveData}>
                <Row>
                  <>
                    <Col xs={24} md={12}>
                      <Form.Item
                        required
                        label="Username"
                        validateStatus={error && error.username ? 'error' : false}
                        help={error && error.username ? error.username[0] : false}
                      >
                        <Input
                          value={data.username}
                          onChange={(e) => handleChange('username', e.target.value)}
                        />
                      </Form.Item>

                      <Form.Item
                        required
                        label="Full Name"
                        validateStatus={error && error.full_name ? 'error' : false}
                        help={error && error.full_name ? error.full_name[0] : false}
                      >
                        <Input
                          value={data.full_name}
                          onChange={(e) => handleChange('full_name', e.target.value)}
                        />
                      </Form.Item>

                      <Form.Item
                        required
                        label="NPK"
                        validateStatus={error && error.npk ? 'error' : false}
                        help={error && error.npk ? error.npk[0] : false}
                      >
                        <Input
                          value={data.npk}
                          onChange={(e) => handleChange('npk', e.target.value)}
                        />
                      </Form.Item>

                      <Form.Item
                        required
                        label="Division"
                        validateStatus={error && error.division ? 'error' : false}
                        help={error && error.division ? error.division[0] : false}
                      >
                        <Input
                          value={data.division}
                          onChange={(e) => handleChange('division', e.target.value)}
                        />
                      </Form.Item>

                      <Form.Item
                        required
                        label="Department"
                        validateStatus={error && error.department ? 'error' : false}
                        help={error && error.department ? error.department[0] : false}
                      >
                        <Input
                          value={data.department}
                          onChange={(e) => handleChange('department', e.target.value)}
                        />
                      </Form.Item>

                      <Form.Item
                        required
                        label="Position"
                        validateStatus={error && error.position ? 'error' : false}
                        help={error && error.position ? error.position[0] : false}
                      >
                        <Input
                          value={data.position}
                          onChange={(e) => handleChange('position', e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        required
                        label="Email"
                        validateStatus={error && error.email ? 'error' : false}
                        help={error && error.email ? error.email[0] : false}
                      >
                        <Input
                          value={data.email}
                          onChange={(e) => handleChange('email', e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Password Baru"
                        validateStatus={error && error.password ? 'error' : false}
                        help={error && error.password ? error.password[0] : false}
                      >
                        <Input.Password
                          value={data.password}
                          placeholder="Kosongkan jika tidak ingin mengubah"
                          onChange={(e) => handleChange('password', e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Confirm Password"
                        validateStatus={error && error.password_confirmation ? 'error' : false}
                        help={error && error.password_confirmation ? error.password_confirmation[0] : false}
                      >
                        <Input.Password
                          value={data.password_confirmation}
                          placeholder="Kosongkan jika tidak ingin mengubah"
                          onChange={(e) => handleChange('password_confirmation', e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>

                      <Form.Item
                        label="Number Phone"
                        validateStatus={error && error.number_phone ? 'error' : false}
                        help={error && error.number_phone ? error.number_phone[0] : false}
                      >
                        <Input
                          value={data.number_phone}
                          onChange={(e) => handleChange('number_phone', e.target.value)}
                        />
                      </Form.Item>

                      <Form.Item 
                      required 
                      label="User Type "
                      validateStatus={error && error.user_type ? 'error' : false}
                      help={error && error.user_type ? error.user_type[0] : false}
                      >
                        <Select
                          // labelInValue
                          onChange={(value) => handleChange('user_type', value)}
                          value={data.user_type}
                        >
                          <Option value="Internal">Internal</Option>
                          <Option value="External">External</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item label="Verifikasi 2 Langkah">
                        <Space direction="vertical">
                          <Switch
                            checked={data.two_factor_enabled}
                            onChange={(value) => handleChange('two_factor_enabled', value)}
                          />
                          <span>{data.two_factor_enabled ? 'Aktif' : 'Nonaktif'}</span>
                          {data.two_factor_enabled && (
                            <Checkbox.Group
                              value={data.two_factor_methods}
                              onChange={(value) => handleChange('two_factor_methods', value)}
                            >
                              <Space direction="vertical">
                                <Checkbox value="authenticator">QR Authenticator</Checkbox>
                                <Checkbox value="email">OTP Email</Checkbox>
                              </Space>
                            </Checkbox.Group>
                          )}
                        </Space>
                      </Form.Item>

                      <Form.Item label="Vendor">
                        <Select
                          labelInValue
                          disabled={data.user_type === 'Internal'}
                          value={data.user_type === 'Internal' ? { key: '', label: '' } : { key: data.vendor_id, label: data.vendor_name }}
                          onChange={(value) => handleChangeSelectVendor('vendor', value, data._id)}
                          onFocus={() => getVendor('')}
                          showSearch
                          loading={loadVendor}
                          onSearch={(value) => getVendor(value)}
                          filterOption={false}
                        >
                          {vendor
                            && vendor.map((val) => (
                              <Option
                                value={val.id}
                                key={Math.random()}
                              >
                                {val.name}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                      
                      <Form.Item label="Role User Destination">
                        <Select
                          labelInValue
                          onChange={(value) => handleChangeSelect('role_user_destination', value)}
                          onFocus={() => getRoleNameProjects('')}
                          showSearch
                          onSearch={(value) => getRoleNameProjects(value)}
                          filterOption={false}
                          value={{ key: data.role_user_destination_id, label: data.role_user_destination_name }}
                        >
                          {roleApp
                            && roleApp.map((val) => (
                              <Option
                                value={val.id}
                                key={Math.random()}
                              >
                                {val.name}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>

                      <Form.Item required label="Role SSO">
                        <Select
                          labelInValue
                          value={{ key: data.role_id, label: data.role_name }}
                          onChange={(value) => handleChangeSelect('role', value)}
                          onFocus={() => getRole('')}
                          showSearch
                          onSearch={(value) => getRole(value)}
                          filterOption={false}
                          validateStatus={error && error.role_id ? 'error' : false}
                      help={error && error.role_id ? error.role_id[0] : false}
                        >
                          {data.roles
                            && data.roles.map((role) => (
                              <Option value={role._id} key={role._id}>
                                {role.name}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                      
                      <Form.Item label="Role Apps">
                          <div>
                              <Menu
                                style={{ borderRight: 'transparent' }}
                                mode="inline"
                                className="menu-permission"
                              >
                                  <SubMenu
                                    key={getApps.length}
                                    title={(
                                      <Space>
                                        <Switch
                                          checked={
                                            data.roles_apps_status
                                            ? data.roles_apps_status : false
                                          }
                                          value={data.roles_apps_status}
                                          onChange={(value) => handleChange(
                                            "roles_apps_status",
                                            value
                                          )}
                                        />
                                        <span>
                                          Apps
                                        </span>
                                      </Space>
                                    )}
                                  >
                                    {getApps.map((apps_data, index) => (
                                      <Menu.Item 
                                      key={index}
                                      >
                                        <Space>
                                          <Switch
                                            checked={roleApps[apps_data._id] ? roleApps[apps_data._id] : false }
                                            value={apps_data._id}
                                            onChange={(value) => handleChangeSwitch(
                                              apps_data._id,
                                              value
                                            )}
                                          />
                                          <span>
                                            {apps_data.application_name}
                                          </span>
                                        </Space>
                                      </Menu.Item>
                                    
                                    ))}
                                  </SubMenu>
                              </Menu>
                          </div>
                      </Form.Item>
                      <Form.Item name="photo" label="Photo">
                        <>
                          <Upload
                            onRemove={handleRemove}
                            beforeUpload={handleBeforeUpload}
                            fileList={[]}
                          >
                            <Button>
                              Upload
                              {' '}
                              <UploadOutlined />
                            </Button>
                          </Upload>
                          {data.photo && (
                            <List>
                              <List.Item
                                actions={[
                                  <Button onClick={handleRemove} type="danger" ghost>
                                    <DeleteOutlined />
                                  </Button>,
                                ]}
                              >
                                <List.Item.Meta description={data.photo.name} />
                              </List.Item>
                            </List>
                          )}
                        </>
                      </Form.Item>
                    </Col>

                    <Row type="flex" gutter={[10, 20]} justify="space-around">
                      <Col>
                        <Button
                          loading={loading}
                          type="primary"
                          htmlType="submit"
                          className="mr-button btn-success"
                        >
                          Submit
                        </Button>
                        <Button htmlType="reset" onClick={handleReset}>
                          Reset
                        </Button>
                      </Col>
                    </Row>
                  </>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </Content>
    </>
  );
}

export default EditUser;
